export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13768.76f7f643.jpg";